import {shareManagerConstants} from "../redux_constants/shareManager.constant";

const InitialState = {
    slideModalOpen: false,
    caseModalOpen: false,
    slidelist: [],
    caselist: [],
    link_expiration: null,
}

export const shareManagerReducer = (state = InitialState, action) => {
    switch (action.type) {
        case shareManagerConstants.CHANGE_SLIDE_MODAL_OPEN_STATE:
            if (state.slideModalOpen) {
                //Will close the modal and reset the state to initial state
                return InitialState
            } else {
                return {
                    ...state,
                    slideModalOpen: !state.slideModalOpen,
                }
            }
        case shareManagerConstants.CHANGE_CASE_MODAL_OPEN_STATE:
            if (state.caseModalOpen) {
                //Will close the modal and reset the state to initial state
                return InitialState
            } else {
                return {
                    ...state,
                    caseModalOpen: !state.caseModalOpen,
                }
            }
        case shareManagerConstants.ADD_SLIDES_TO_SHARE:
            // Adds single or list of slides to the slide list
            // Will open the modal if it is not already open
            let {slides = []} = action
            if (!Array.isArray(slides)) {
                slides = [slides]
            }
            return {
                ...state,
                slideModalOpen: true,
                slidelist: [...state.slidelist, ...slides]
            }
        case shareManagerConstants.ADD_CASES_TO_SHARE:
            // Adds single or list of cases to the case list
            // Will open the modal if it is not already open
            let {cases = []} = action
            if (!Array.isArray(cases)) {
                cases = [cases]
            }
            return {
                ...state,
                caseModalOpen: true,
                caselist: [...state.caselist, ...cases]
            }

        case shareManagerConstants.CHANGE_LINK_EXPIRATION:
            // Changes the link expiration date
            const {link_expiration} = action
            return {
                ...state,
                link_expiration: link_expiration
            }
        case shareManagerConstants.REMOVE_LINK_EXPIRATION:
            return {
                ...state,
                link_expiration: null
            }

        default :
            return state
    }
}